const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20from%20a%20Chinese%20historical%20costume%20drama%20with%20two%20characters%20in%20traditional%20elegant%20robes%20standing%20in%20an%20ancient%20courtyard%20with%20blossoming%20trees%2C%20warm%20golden%20hour%20lighting%2C%20soft%20cinematic%20depth%20of%20field%2C%20emotional%20atmosphere%2C%20film%20grain%20texture&width=600&height=340&seq=media-card-pipi-01&orientation=landscape',
    title: '长风渡',
    tag: '热播中',
    desc: '白敬亭宋轶演绎先婚后爱古装巨制',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Intense%20crime%20drama%20scene%20with%20two%20middle-aged%20men%20in%20a%20dimly%20lit%20interrogation%20room%2C%20one%20in%20police%20uniform%20the%20other%20in%20casual%20clothes%2C%20tense%20atmosphere%2C%20dramatic%20shadows%2C%20warm%20amber%20light%20from%20a%20single%20overhead%20lamp%2C%20cinematic%20composition&width=600&height=340&seq=media-card-pipi-02&orientation=landscape',
    title: '狂飙',
    tag: '高分推荐',
    desc: '张译张颂文演技封神年度现象级作品',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20scene%20with%20a%20woman%20in%20flowing%20white%20celestial%20dress%20floating%20among%20clouds%20and%20starlight%2C%20magical%20particles%20and%20soft%20glowing%20aurora%2C%20dreamy%20atmosphere%2C%20warm%20peach%20and%20golden%20tones%2C%20cinematic%20fantasy%20aesthetic&width=600&height=340&seq=media-card-pipi-03&orientation=landscape',
    title: '星落凝成糖',
    tag: '新剧上线',
    desc: '陈星旭李兰迪绝美仙侠虐恋新篇章',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20office%20newsroom%20scene%20with%20professional%20women%20in%20sharp%20business%20attire%20intensely%20discussing%20at%20a%20glass%20conference%20table%2C%20city%20skyline%20visible%20through%20large%20windows%2C%20warm%20evening%20light%2C%20cinematic%20composition&width=600&height=340&seq=media-card-pipi-04&orientation=landscape',
    title: '新闻女王',
    tag: '港剧热播',
    desc: '佘诗曼回归TVB演绎职场宫斗风暴',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20scene%20with%20a%20traditional%20Chinese%20wooden%20house%20surrounded%20by%20green%20rice%20fields%20and%20distant%20mountains%2C%20warm%20sunset%20golden%20light%2C%20a%20group%20of%20friends%20cooking%20outdoors%2C%20relaxed%20and%20nostalgic%20atmosphere&width=600&height=340&seq=media-card-pipi-05&orientation=landscape',
    title: '向往的生活',
    tag: '综艺热门',
    desc: '何炅黄磊温情收官治愈系慢生活',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选品质好剧，每一部都值得你花时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 rounded-full bg-background-950/70 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}